import React, { useState } from 'react';

interface ShiftPopupModalProps {
    isOpen: boolean;
    currentShift: string;
    onClose: () => void;
    onShiftChange: (newShift: string) => void;
}

const ShiftPopupModal: React.FC<ShiftPopupModalProps> = ({
    isOpen,
    currentShift,
    onClose,
    onShiftChange
}) => {
    const [selectedShift, setSelectedShift] = useState(currentShift || "Shift 1");

    if (!isOpen) return null;

    const handleDone = () => {
        onShiftChange(selectedShift);
        onClose();
    };

    return (
        <div id="shiftPopup" className="main-popup shift-popup is-popup-active">
            <div className="popup-bg" onClick={onClose}></div>
            <div className="popup-content">
                <div className="popup-common-box">
                    <div className="popup-header">
                        <h4 className="popup-header-title">Select your shift</h4>
                        <button type="button" className="bs-btn popup-close-btn" onClick={onClose}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                <path d="M11 1L1 11M1 1L11 11" stroke="#6D757E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </button>
                    </div>
                    <div className="popup-body">
                        <div className="shift-popup-content-wrapper">
                            <label className="form-label">Shift</label>
                            <select
                                id="shiftSelect"
                                className="form-select"
                                value={selectedShift}
                                onChange={(e) => setSelectedShift(e.target.value)}
                            >
                                <option value="Shift 1">Shift 1</option>
                                <option value="Shift 2">Shift 2</option>
                                <option value="Shift 3">Shift 3</option>
                            </select>
                        </div>
                    </div>
                    <div className="popup-footer">
                        <button type="button" className="bs-btn bs-btn-outline-primary" onClick={onClose}>
                            Cancel
                        </button>
                        <button type="button" className="bs-btn bs-btn-primary" onClick={handleDone}>
                            Done
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ShiftPopupModal;
